import { ParsedJwt } from 'types/parsed-jwt';

type OAuthParams = ParsedJwt & {
  prompt?: string;
  no_sign_up?: string;
  new_signin?: string;
};

export const buildOauthQuery = (cfg: OAuthParams = {}): string => {
  const query = [];
  query.push(`client_id=${encodeURIComponent(cfg.client_id)}`);
  query.push(`redirect_uri=${encodeURIComponent(cfg.redirect_uri)}`);
  query.push(`response_type=${encodeURIComponent(cfg.response_type)}`);

  if (cfg.organization_id) {
    query.push(`organization_id=${encodeURIComponent(cfg.organization_id)}`);
  }

  if (cfg.flow) {
    query.push(`flow=${encodeURIComponent(cfg.flow)}`);
  }

  if (cfg.state) {
    query.push(`state=${encodeURIComponent(cfg.state)}`);
  }

  if (cfg.code_challenge) {
    query.push(`code_challenge=${encodeURIComponent(cfg.code_challenge)}`);
  }

  if (cfg.code_challenge_method) {
    query.push(`code_challenge_method=${encodeURIComponent(cfg.code_challenge_method)}`);
  }

  if (cfg.prompt) {
    query.push(`prompt=${encodeURIComponent(cfg.prompt)}`);
  }

  if (cfg.no_sign_up === '1') {
    query.push(`no_sign_up=${encodeURIComponent(cfg.no_sign_up)}`);
  }

  if (cfg.new_signin === '1') {
    query.push(`new_signin=${encodeURIComponent(cfg.new_signin)}`);
  }

  return query.join('&');
};
